import { Component } from '@angular/core';
import { ButtonDirective } from '@innersource/common-ui-components';

@Component({
  selector: 'app-vector-db',
  templateUrl: './vector-db.component.html',
  styleUrls: ['./vector-db.component.scss'],
  imports: [ButtonDirective],
})
export class VectorDbComponent {
  readonly sources = [];
}
